import React from 'react';
import { useFormContext } from 'react-hook-form';

import { usePreloadImages } from '../../hooks/usePreloadImages';
import { LayoutDataType } from '../../types';

import { ScreenEthnicity as ScreenEthnicityFemale } from './Female';
import { ScreenEthnicity as ScreenEthnicityMale } from './Male';

export const ScreenEthnicity: React.FC = () => {
  usePreloadImages();

  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenEthnicityMale />;
  }

  return <ScreenEthnicityFemale />;
};
